module.exports = __webpack_public_path__ + "static/media/bg.e1a8700f.webp";